import { createFeatureSelector, createSelector } from '@ngrx/store';
import { MapStyleState } from './map-style.state';

export const mapStyleFeatureKey = 'mapStyle';

export const getMapStyleState = createFeatureSelector<MapStyleState>(mapStyleFeatureKey);
export const getMapStyle = createSelector(getMapStyleState, (state: MapStyleState) => state.mapStyle);
